module.exports = __webpack_public_path__ + "img/rent1.be1c12ba.jpg";